import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4731bb7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trips-analytics-filters__container" }
const _hoisted_2 = { class: "trips-analytics-filters__actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "trips-analytics-filters",
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_input, {
        placeholder: "Номер рейса",
        disabled: _ctx.loading,
        value: _ctx.state.tripNumber,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tripNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        placeholder: "Город отправления",
        "can-deselect": "",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        options: _ctx.data_state.cities.list,
        value: _ctx.state.fromCityId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.fromCityId) = $event)),
        onRefresh: _ctx.loadCities
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Город прибытия",
        "can-deselect": "",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        options: _ctx.data_state.cities.list,
        value: _ctx.state.toCityId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.toCityId) = $event)),
        onRefresh: _ctx.loadCities
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Логист",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.logists.is_loading,
        failed: _ctx.data_state.logists.is_failed,
        options: _ctx.data_state.logists.list,
        value: _ctx.state.logistId,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.logistId) = $event)),
        onRefresh: _ctx.loadLogists
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_input, {
        type: "date",
        placeholder: "Дата отправления рейса от",
        value: _ctx.state.departureDateFrom,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.departureDateFrom) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_new_input, {
        type: "date",
        placeholder: "Дата отправления рейса по",
        value: _ctx.state.departureDateTo,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.departureDateTo) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_new_input, {
        type: "date",
        placeholder: "Дата прибытия рейса от",
        value: _ctx.state.arrivalDateFrom,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.arrivalDateFrom) = $event)),
        disabled: _ctx.loading,
        "is-invalid": _ctx.state_form$.arrivalDateFrom.$error,
        "validation-errors": _ctx.state_form$.arrivalDateFrom.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_new_input, {
        type: "date",
        placeholder: "Дата прибытия рейса по",
        value: _ctx.state.arrivalDateTo,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.arrivalDateTo) = $event)),
        disabled: _ctx.loading,
        "is-invalid": _ctx.state_form$.arrivalDateTo.$error,
        "validation-errors": _ctx.state_form$.arrivalDateTo.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_new_select, {
        placeholder: "Утилизация",
        "can-deselect": "",
        multiselect: "",
        searchable: false,
        disabled: _ctx.loading,
        options: _ctx.UTILIZATION_OPTIONS,
        value: _ctx.state.utilizationIds,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.utilizationIds) = $event))
      }, null, 8, ["disabled", "options", "value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_button, {
        type: "button",
        disabled: _ctx.loading,
        class: "NewButton--reset",
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_new_button, {
        type: "submit",
        loading: _ctx.loading,
        class: "NewButton--search"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}